import {
    put,
    call,
    takeLatest
} from 'redux-saga/effects'

import fetch from '../../../api/fetch'

import * as types from '../../../constants/quote/step02'

export function* fetchMuseumsSaga() {
    try {
        yield put({ type: types.FETCH_MUSEUMS_REQUEST })
        const response = yield call( fetch, '/museums', { method: 'GET' } )
        yield put({
            type: types.FETCH_MUSEUMS_SUCCESS,
            payload: response,
        })
    } catch (error) {
        yield put({
            type: types.FETCH_MUSEUMS_FAILURE,
            payload: error,
        })
    } finally {
        yield put({ type: types.FETCH_MUSEUMS_FULFILL })
    }
}

export function* watchFetchMuseumsSaga() {
    yield takeLatest( types.FETCH_MUSEUMS_TRIGGER, fetchMuseumsSaga )
}

export function* fetchStorageLocationsSaga() {
    try {
        yield put({ type: types.FETCH_STORAGE_LOCATIONS_REQUEST })
        const response = yield call( fetch, '/storage_locations', { method: 'GET' } )
        yield put({
            type: types.FETCH_STORAGE_LOCATIONS_SUCCESS,
            payload: response,
        })
    } catch (error) {
        yield put({
            type: types.FETCH_STORAGE_LOCATIONS_FAILURE,
            payload: error,
        })
    } finally {
        yield put({ type: types.FETCH_STORAGE_LOCATIONS_FULFILL })
    }
}

export function* watchFetchStorageLocationsSaga() {
    yield takeLatest( types.FETCH_STORAGE_LOCATIONS_TRIGGER, fetchStorageLocationsSaga )
}

export default [
    watchFetchMuseumsSaga(),
    watchFetchStorageLocationsSaga(),
]



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/quote/step02/index.ts